import basisTheoryCheckoutEngine from 'payments/core/engines/basisTheory';
import { registerHandler } from '../paymentHandlerRegistry';

/** Submit the mounted Basis Theory checkout when it owns card capture. */
registerHandler('credit_card', {
  canHandle: ({ cardCheckoutMode }) => cardCheckoutMode === 'basis_theory',
  execute: async () => basisTheoryCheckoutEngine.submit(),
});
